import React from "react";
import styled from "styled-components";

import LineSeedKrRg from "../../../../atoms/text/lineSeedKr/lineSeedKrRg";

const LSRgDisplay03 = (props) => {
  return <LSRgDisplay03Wrapper {...props} />;
};

export default LSRgDisplay03;

const LSRgDisplay03Wrapper = styled(LineSeedKrRg)`
  font-size: 32px;
  font-weight: 400;
  line-height: 44.8px;
  letter-spacing: -0.6px;

  color: #222222;
`;
